@import '~style-sheet-helpers/core.less';
@import '../../../../../../../../constants/spacing.module.less';

.ims-connection-step {
  text-align: left;
  gap: @space-32;
}

.header {
  font-weight: 700;
}

.description {
  color: var(--gray-56595D);
  margin-top: @space-8;
}

.api-key-section {
  gap: @space-16;
  align-items: flex-start;
}

.section-title {
  font-weight: 600;
}

.section-description {
  color: var(--gray-56595D);
  margin-top: @space-4;
}

.generate-api-button {
  width: fit-content;
  margin-top: @space-8;
}

.content-container {
  background: var(--white);
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  padding: @space-24;
  gap: @space-32;
  margin-bottom: @space-48;
}

.section-divider {
  width: 100%;
  height: 1px;
  background: var(--gray-E4E5E7);
  margin: @space-8 @space-0;
}

.ims-selection-section {
  gap: @space-16;
  align-items: flex-start;
  margin-bottom: @space-32;
}

.ims-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: @space-16;
  width: 100%;
  margin-top: @space-16;
}

.ims-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: @space-24;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  background: var(--white);
  gap: @space-12;
  height: 120px;
  width: 100%;
}

.ims-svg-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.ims-header {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.connect-text {
  margin: 0 @space-4 0 0;
}

.connect-icon {
  width: 12px;
  height: 12px;
}
